import { useQuery } from '@tanstack/react-query';
import { guidesApi, guidesKeys } from '@/features/guides/api/guides.api';

export function useGuide(id: string | undefined) {
  return useQuery({
    queryKey: guidesKeys.detail(id ?? ''),
    queryFn: () => guidesApi.getById(id!),
    enabled: Boolean(id),
  });
}
